import distDlg from './distDlg.js'
import branchDlg from './branchDlg.js'
import branchDlgMul from './branchDlgMul.js'
import userDlg from './userDlg.js'
import userDlgMul from './userDlgMul.js'
import roleDlg from './roleDlg.js'

const platformMan = {
  namespaced: true,
  modules: {
    distDlg,
    branchDlg,
    branchDlgMul,
    userDlg,
    userDlgMul,
    roleDlg,
  }
}

export default platformMan
